<template>
  <Modal position="center" ref="modalRef">
    <template #body>
      <View direction="column" gap="xl">
        <View direction="column" align="center" gap="md">
          <IconTile icon="check-circle" size="large" color="green" shape="rounded" :colored-icon="true" />

          <Text variant="h2">Confirm application acceptance?</Text>
          <Text variant="body-large" color="secondary" align="center" v-if="renterFirstName">
            Confirm that you want to accept {{ renterFirstName }}'s application for this property
          </Text>
        </View>

        <View direction="column" gap="md">
          <Text variant="h4">What happens after you accept:</Text>

          <Card variant="outline" size="medium">
            <View direction="column" gap="md">
              <View direction="row" gap="md">
                <IconTile size="small" color="orange" icon="message-chat-circle" />

                <View direction="column" gap="xs">
                  <Text variant="h5">Tallo will notify other Renters</Text>
                  <Text variant="body-medium" color="secondary">
                    Other interested renters will be notified that this property is no longer available
                  </Text>
                </View>
              </View>
              <View direction="row" gap="md">
                <IconTile size="small" color="orange" icon="pause-circle" />

                <View direction="column" gap="xs">
                  <Text variant="h5">Tallo will put this listing on pause</Text>
                  <Text variant="body-medium" color="secondary">
                    This listing will stay under your “listings” tab for future leasing needs
                  </Text>
                </View>
              </View>
            </View>
          </Card>
        </View>
      </View>
    </template>

    <template #footer>
      <View gap="md" justify="space-between" :grow="1" class="actions">
        <Button @click="modalRef?.close()" variant="ghost">I'll consider further</Button>
        <Button @click="acceptApplication()" :loading="renterProfileStore.bundles.bundleOperationInProgress">
          Accept
        </Button>
      </View>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { useQueryCache } from '@pinia/colada';
import { ref } from 'vue';

import { Modal, View, Text, Card, Button, useAlertsStore, IconTile } from '@tallo/design-system';
import { portfolioQueryKey } from '@tallo/investor/property';

import { useRenterProfileStore } from '../store/renter-profile.store';

const props = defineProps<{
  renterFirstName: string;
  bundleId: string;
}>();

const alerts = useAlertsStore();
const renterProfileStore = useRenterProfileStore();
const queryCache = useQueryCache();

const modalRef = ref<InstanceType<typeof Modal>>();

async function acceptApplication(): Promise<void> {
  await renterProfileStore.acceptBundle(props.bundleId);

  queryCache.invalidateQueries({ key: [portfolioQueryKey] });
  modalRef.value?.close();
  alerts.success('Application accepted');
}

defineExpose({ modalRef });
</script>

<style scoped lang="scss">
.actions > * {
  width: 100%;
}
</style>
